import React, { createContext, useState } from "react";
import { getDetailedCart } from "services/user/cartService";
import { processAddToCart, removeItems } from "services/user/cartService";
import { useEffect } from "react";
import Notification from "component/user/notification/notification";
import { PacmanLoader } from "react-spinners";
import Swal from "sweetalert2";

export const CartContext = createContext();
export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const token = localStorage.getItem("token");
  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const savedCartCount = localStorage.getItem("itemQuantityInCart");
    if (savedCartCount) {
      setCartCount(Number(savedCartCount));
    }
  }, []);
  useEffect(() => {
    fetchCartCount();
  }, []);

  const fetchCartCount = async () => {
    try {
      const cartData = await getDetailedCart(token);
      setCartCount(cartData.data.totalDistinctItems);
    } catch (error) {
      console.error("Error fetching cart details:", error);
    }
  };

  const addToCart = async (bookID, quantity) => {
    try {
      setIsLoading(true);
      const responseData = await processAddToCart(token, bookID, quantity);
      if (responseData.message === "Added to cart successfully!") {
        // localStorage.removeItem("itemQuantityInCart");
        setNotification("Thêm vào giỏ hàng thành công!");
        setCartCount(responseData.data.totalDistinctItems);
        localStorage.setItem(
          "itemQuantityInCart",
          responseData.data.totalDistinctItems
        );
      } else if (responseData.message === "Not enough items in stock!") {
        setNotification("Shop không đủ sản phẩm bạn muốn mua.");
      }
      return responseData;
    } catch (error) {
      if (error.message === "Not enough items in stock!") {
        Swal.fire({
          icon: "error",
          title: "Lỗi!",
          text: "Sách hiện không có đủ số lượng!",
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "my-swal",
          },
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const removeFromCart = async (bookID) => {
    try {
      setIsLoading(true);
      // console.log("bookIDddd:", bookID);
      const response = await removeItems(token, bookID);
      // console.log("cartcount response:", response.data.data.totalDistinctItems);
      if (response?.status === 200) {
        // localStorage.removeItem("itemQuantityInCart")
        setCartCount(response.data.data.totalDistinctItems); // Cập nhật cartCount
        localStorage.setItem(
          "itemQuantityInCart",
          response.data.data.totalDistinctItems
        );
        // console.log("Cart count updated to:", response.data.data.totalDistinctItems); // Kiểm tra log này
      }
      return response;
    } catch (error) {
      console.error("Error removing item:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CartContext.Provider
      value={{ cartCount, addToCart, removeFromCart, fetchCartCount }}
    >
      {children}
      {notification && (
        <Notification
          message={notification}
          onClose={() => setNotification(null)}
        />
      )}

      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </CartContext.Provider>
  );
};
